import {
  IEnum,
  IMDMUnit,
  IMDMUnitInstance,
  IPassportGroup,
  IPassportSchema,
  TCreateEnumDTO,
  TCreateMDMUnitDTO,
  TCreatePassportGroupDTO,
  TCreatePassportSchemaDTO,
  TCreateUnitInstanceDTO,
} from './mdm.types'
import { HTTPResponse } from '@/services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '../../services/http'

const createEnum = (dto: TCreateEnumDTO): Promise<HTTPResponse<IEnum>> => {
  return http.post(`/nsi/v1/mdm/enums`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateEnum = (dto: TCreateEnumDTO, id: IEnum['id']): Promise<HTTPResponse<IEnum>> => {
  return http
    .patch(`/nsi/v1/mdm/enums/` + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteEnum = (id: IEnum['id']): Promise<HTTPResponse<IEnum>> => {
  return http
    .delete(`/nsi/v1/mdm/enums/` + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const createUnit = (dto: TCreateMDMUnitDTO): Promise<HTTPResponse<IMDMUnit>> => {
  const normalizedDTO: TCreateMDMUnitDTO = JSON.parse(JSON.stringify(dto))
  for (let i = 0; i < normalizedDTO.fields.length; ++i) {
    if (normalizedDTO.fields[i].typeEnumId === null) {
      delete normalizedDTO.fields[i].typeEnumId
    }
  }

  return http.post(`/nsi/v1/mdm/units/schemas`, normalizedDTO).then(handleHttpResponse).catch(handleHttpError)
}

const updateUnit = (dto: TCreateMDMUnitDTO, id: IMDMUnit['id']): Promise<HTTPResponse<IMDMUnit>> => {
  const normalizedDTO: TCreateMDMUnitDTO = JSON.parse(JSON.stringify(dto))
  for (let i = 0; i < normalizedDTO.fields.length; ++i) {
    if (normalizedDTO.fields[i].typeEnumId === null) {
      delete normalizedDTO.fields[i].typeEnumId
    }
    if (!normalizedDTO.fields[i].defaultValue) {
      delete normalizedDTO.fields[i].defaultValue
    }
  }

  return http
    .patch(`/nsi/v1/mdm/units/schemas/` + id, normalizedDTO)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteUnit = (id: IMDMUnit['id']): Promise<HTTPResponse<IMDMUnit>> => {
  return http
    .delete(`/nsi/v1/mdm/units/schemas/` + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const createUnitInstance = (dto: TCreateUnitInstanceDTO): Promise<HTTPResponse<IMDMUnitInstance>> => {
  return http.post(`/nsi/v1/mdm/units/instances`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateUnitInstance = (
  dto: TCreateUnitInstanceDTO,
  id: IMDMUnitInstance['id']
): Promise<HTTPResponse<IMDMUnitInstance>> => {
  return http
    .patch(`/nsi/v1/mdm/units/instances` + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteUnitInstance = (id: IMDMUnitInstance['id']): Promise<HTTPResponse<IMDMUnitInstance>> => {
  return http
    .delete(`/nsi/v1/mdm/units/instances` + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const createPassportSchema = (dto: TCreatePassportSchemaDTO): Promise<HTTPResponse<IPassportSchema>> => {
  return http.post(`/nsi/v1/mdm/passports/schemas`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const updatePassportSchema = (
  dto: TCreatePassportSchemaDTO,
  id: IPassportSchema['id']
): Promise<HTTPResponse<IPassportSchema>> => {
  return http
    .patch(`/nsi/v1/mdm/passports/schemas/` + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deletePassportSchema = (id: IPassportSchema['id']): Promise<HTTPResponse<IPassportSchema>> => {
  return http
    .delete(`/nsi/v1/mdm/passports/schemas/` + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const createPassportSchemaGroup = (dto: TCreatePassportGroupDTO): Promise<HTTPResponse<IPassportGroup>> => {
  return http.post(`/nsi/v1/mdm/passports/groups`, dto).then(handleHttpResponse).catch(handleHttpError)
}

const updatePassportSchemaGroup = (
  dto: TCreatePassportGroupDTO,
  id: IPassportGroup['id']
): Promise<HTTPResponse<IPassportGroup>> => {
  return http
    .patch(`/nsi/v1/mdm/passports/groups/` + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deletePassportSchemaGroup = (id: IPassportGroup['id']): Promise<HTTPResponse<IPassportGroup>> => {
  return http
    .delete(`/nsi/v1/mdm/passports/groups/` + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const mdmApi = {
  createEnum,
  updateEnum,
  deleteEnum,
  createUnit,
  updateUnit,
  deleteUnit,
  createUnitInstance,
  updateUnitInstance,
  deleteUnitInstance,
  createPassportSchema,
  updatePassportSchema,
  deletePassportSchema,
  createPassportSchemaGroup,
  updatePassportSchemaGroup,
  deletePassportSchemaGroup,
}

export default mdmApi
